import React, { FC } from "react"
import { Box, Flex } from "@mantine/core"
import ErrorBoundaryCard from "./ErrorBoundaryCard"

const AppErrorFallback: FC = () => (
    <Flex h="100svh" w="100vw" justify="center" align="center">
        <Box w={`clamp(0px, 780px, 100%)`}>
            <ErrorBoundaryCard />
        </Box>
    </Flex>
)

export default AppErrorFallback
